import { ACLInheritDataStepDto } from './aclInheritDataStep.dto';
import { BaseDto } from './base.dto';
export class ACLInheritDataTaskDto extends BaseDto{  
    name: string;
    description: string;
    enabled: boolean;
    steps?: ACLInheritDataStepDto[];
}